import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import { useSelect } from '@/pages/innerTransConfig/api';
import React from 'react';
export const SelectInnerTransConfig = ({
  value,
  onChange,
  placeholder = '全部'
}) => {
  const {
    data,
    isLoading
  } = useSelect({
    params: {
      pageSize: 100,
      pageIndex: 1
    }
  });
  return /*#__PURE__*/React.createElement(_Select, {
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    loading: isLoading,
    options: data ? data.data.items.map(v => ({
      label: `${v.from_coin}/${v.to_coin}_1:${v.rate}`,
      value: v.id
    })) : [],
    allowClear: true
  });
};